<template>
    <div id="apply-to-join-layout">
        <loading :loading="loading" :full-page="true"/>
        <section id="beach-section">
            <div class="container">
                <h1>Benefits unlike <br>any other stock library</h1>
                <div id="benefits-row">
                    <div class="benefit">
                        <strong>50%</strong>
                        <span>Commission</span>
                    </div>
                    <div class="d-inline-block plus">+</div>
                    <div class="benefit">
                        <span>Talent fee</span>
                        <span>paid by us</span>
                    </div>
                    <div class="d-inline-block plus">+</div>
                    <div class="benefit">
                        <span>We'll tag</span>
                        <span>your images</span>
                    </div>
                </div>
                <div class="apply-now-row"><a href="#application" @click.prevent="scrollTo('signup-section')">Apply Now</a></div>
            </div>
        </section>
        <section id="contribute-about-section">
            <div class="container">
                <div class="row contribute-about-section__row">
                    <div class="order-2 order-lg-1 col-12 col-lg-4 col-xl-3">
                        <h2>Looking to join forces to create some magic?</h2>
                        <template v-if="locale === 'nz'">
                            <p>We're looking for local lifestyle photographers from across Aotearoa with an entrepreneurial streak.</p>
                            <p>
                                Our clients range from creative agencies to Government departments New Zealand wide, hungry to buy well-shot local Aotearoa
                                stock images.
                            </p>
                            <p>We pay the highest commission in the world of 50% from all your sales.</p>
                        </template>
                        <template v-else>
                            <p>We're looking for local Australian lifestyle photographers with an entrepreneurial streak.</p>
                            <p>
                                Our clients range from creative agencies to Government departments Australia wide, hungry to buy well-shot local Australian
                                stock images.
                            </p>
                            <p>We pay the highest commission in the world of 50% from all your sales.</p>
                        </template>
                    </div>
                    <div class="order-1 order-lg-2 col-12 col-lg-7 col-xl-8 offset-lg-1">
                        <img :src="`${assetsUrl}static-backgrounds/apply-about-1.jpg`" class="w-100">
                    </div>
                </div>
                <div class="row contribute-about-section__row">
                    <div class="col-12 col-lg-7 col-xl-8">
                        <img :src="`${assetsUrl}static-backgrounds/apply-about-2.jpg`" class="w-100">
                    </div>
                    <div class="col-12 col-lg-4 col-xl-3 offset-lg-1">
                        <h2>What we're after</h2>
                        <p>We're after photographers that can direct models to capture that candid but campaign-ready look.</p>
                        <p>Most of our photographers have experience in directing models and working with good light to create those magic moments.</p>
                        <p>
                            Quite different to street or event photography, our photographers create scenarios working closely with their models based on
                            the location and their experience.
                        </p>
                        <p>We also accept drone and landscape photographers with unique content.</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="contribute-reasons-section" class="dark">
            <div class="container">
                <div class="row">
                    <div class="col-12 contribute-reasons-section__col">
                        <h2>How our contributors create their library</h2>
                        <p v-if="locale === 'nz'">
                            Though some photographers already have an existing library of assets to be sold, here's the typical process of how <br
                            class="d-none d-sm-block"
                        >our contributors
                            create new content, ready to be sold across Aotearoa. We help every step of the way.
                        </p>
                        <p v-else>
                            Though some photographers already have an existing library of assets to be sold, here’s the typical process of how <br
                            class="d-none d-sm-block"
                        >our contributors
                            create new content, ready to be sold across Australia. We help every step of the way.
                        </p>
                    </div>
                </div>
                <div class="row contribute-reasons-section__row">
                    <div class="col-12 col-sm-6 col-md-3">
                        <span>1.</span>
                        <p>
                            Proactively find models <br class="d-none d-sm-block">(this could be professional <br class="d-none d-sm-block">models, mates,
                            business <br class="d-none d-sm-block">owners or family). Guidance <br class="d-none d-sm-block">is provided.
                        </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <span>2.</span>
                        <p>
                            Organise shoots based on <br class="d-none d-sm-block">data and insights we provide.<br><br>
                            Talent releases signed.<br><br>
                            We pay the talent directly <br class="d-none d-sm-block">after each shoot.
                        </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <span>3.</span>
                        <p>
                            Upload all assets to our state of <br class="d-none d-sm-block">the art contributor portal.<br><br>
                            We tag and keyword all your <br class="d-none d-sm-block">images, ready to be sold.
                        </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <span>4.</span>
                        <p>
                            When images sell you get paid <br class="d-none d-sm-block">50% commission into your bank <br class="d-none d-sm-block">account
                            monthly.<br><br>
                            How much do images sell for you <br class="d-none d-sm-block">ask? See our
                            <nuxt-link :to="{ name: 'pre-purchase' }" class="pointer text-decoration-none">pricing page</nuxt-link>
                            .
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section id="signup-section" class="dark">
            <div class="container">
                <div id="apply-row" class="row">
                    <div class="col-12">
                        <h1 class="apply-heading">Apply to join if you're a professional photographer<br class="d-none d-sm-block"> or a production agency</h1>
                    </div>
                    <div class="col-md-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <form id="application" class="needs-validation" @submit.prevent="applyNow" @keydown="form.onKeydown($event)">
                            <input id="upload-hash" type="hidden" name="upload-hash" value="">
                            <div class="form-row">
                                <div class="form-group col-md-6  col-sm-12">
                                    <label for="first-name" class="sr-only">First Name</label>
                                    <input
                                        id="first-name" v-model="form.name" type="text" class="form-control" placeholder="First Name" autocomplete="off"
                                        :class="{ 'is-invalid': form.errors.has('name') }"
                                    >
                                    <has-error :form="form" field="name"/>
                                </div>
                                <div class="form-group col-md-6  col-sm-12">
                                    <label for="last-name" class="sr-only">Last Name</label>
                                    <input
                                        id="last-name" v-model="form.last_name" type="text" class="form-control" placeholder="Last Name" autocomplete="off"
                                        :class="{ 'is-invalid': form.errors.has('last_name') }"
                                    >
                                    <has-error :form="form" field="last_name"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="email" class="sr-only">Email</label>
                                    <input
                                        id="email" v-model="form.email" type="email" class="form-control" placeholder="Email" autocomplete="off"
                                        :class="{ 'is-invalid': form.errors.has('email') }"
                                    >
                                    <has-error :form="form" field="email"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="website" class="sr-only">Professional Portfolio Website</label>
                                    <input
                                        id="website" v-model="form.website" type="text" class="form-control" placeholder="Professional Portfolio Website"
                                        autocomplete="off" :class="{ 'is-invalid': form.errors.has('website') }"
                                    >
                                    <has-error :form="form" field="website"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="mobile" class="sr-only">Mobile No.</label>
                                    <input
                                        id="mobile" v-model="form.mobile" type="text" class="form-control" placeholder="Mobile No." autocomplete="off"
                                        :class="{ 'is-invalid': form.errors.has('mobile') }"
                                    >
                                    <div class="hint-text">Emails sometimes go to spam, so we might message to organise a call</div>
                                    <has-error :form="form" field="mobile"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="region" class="sr-only">Region you are based in</label>
                                    <input
                                        id="region" v-model="form.region" type="text" class="form-control" placeholder="Region you are based in"
                                        autocomplete="off" :class="{ 'is-invalid': form.errors.has('region') }"
                                    >
                                    <has-error :form="form" field="region"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-lg-8 col-md-12 check-group-col">
                                    <b-form-checkbox
                                        id="agree"
                                        v-model="form.privacy_policy"
                                        class="form-check"
                                        :class="{ 'is-invalid': form.errors.has('privacy_policy') }"
                                        name="privacy_policy"
                                    >
                                        I have read and agree to the
                                        <a
                                            :href="$router.resolve({ name: 'privacy-policy' }).href" style="font-weight: bold"
                                            @click.prevent="$bvModal.show('privacy-policy-modal')"
                                        >
                                            Privacy Policy
                                        </a>
                                    </b-form-checkbox>
                                    <has-error :form="form" field="privacy_policy"/>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 text-lg-right">
                                    <button type="submit" class="btn btn-primary">
                                        Submit
                                    </button>
                                </div>
                                <div class="col-12 text-center">
                                    <small class="recaptcha-text">This site is protected by reCAPTCHA and the Google
                                        <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and
                                        <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.
                                    </small>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <section id="contributor-profile-pictures">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <h2>Join our growing community of <br class="d-block d-sm-none">diverse local photographers.</h2>
                        <img :src="`${assetsUrl}static-backgrounds/contributor-profiles.jpg`" class="w-100">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Form from 'vform'
import Swal from 'sweetalert2'
import Loading from '~/components/global/Loading.vue'

export default {
    components: {
        Loading
    },
    data () {
        return {
            form: new Form({
                name: '',
                surname: '',
                email: '',
                website: '',
                mobile: '',
                privacy_policy: false,
                region: null,
                token: null,
                cToken: null
            }),
            submitText: null,
            loading: false
        }
    },
    head () {
        const title = 'How to become a Truestock Contributor'
        const description = this.locale === 'nz' ? 'Passionate about capturing authentic Aotearoa life? We\'re looking for a limited number of photographers and videographers, to become our co-owners.' : 'Passionate about capturing authentic Australian life? We\'re looking for a limited number of photographers to become our contributors.'

        return {
            title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: description
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: description
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: description
                },
                {
                    name: 'robots',
                    content: 'index, follow'
                },
                {
                    name: 'keywords',
                    content: this.locale === 'nz' ? 'New Zealand photographer, Aotearoa photography, contributor, photography co-operative' : 'Australian photographer, Australia photography, contributor, photography community'
                }
            ],
            link: [
                {
                    rel: 'canonical',
                    href: `${process.env.appUrl}/apply-to-join`
                }
            ]
            // TODO look into this more
            // script: [
            //     {
            //         type: 'application/ld+json',
            //         json: {
            //             '@context': 'https://schema.org',
            //             '@type': 'JobPosting',
            //             title: `Stock Photographer - ${this.locale === 'nz' ? 'New Zealand' : 'Australia'}`,
            //             description,
            //             hiringOrganization: {
            //                 '@type': 'Organization',
            //                 name: 'Truestock',
            //                 sameAs: process.env.appUrl
            //             },
            //             jobLocation: {
            //                 '@type': 'Place',
            //                 addressCountry: this.locale === 'nz' ? 'NZ' : 'AU'
            //             },
            //             employmentType: 'CONTRACTOR',
            //             baseSalary: {
            //                 '@type': 'MonetaryAmount',
            //                 currency: this.locale === 'nz' ? 'NZD' : 'AUD',
            //                 value: {
            //                     '@type': 'QuantitativeValue',
            //                     value: 50,
            //                     unitText: 'PERCENT'
            //                 }
            //             }
            //         }
            //     }
            // ]
        }
    },
    methods: {
        async applyNow () {
            this.loading = true

            this.form.cToken = await this.$recaptcha.execute('forgot_password')

            this.form.post('/contributor-application/apply')
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Thanks for reaching out',
                        html: 'We will be in touch soon.',
                        confirmButtonText: 'OK'
                    })

                    this.form.reset()
                })
                .catch((e) => {
                    if (e.response && e.response.status === 400 && e.response.data.message === 'Captcha failed') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Captcha verification failed',
                            html: 'Please refresh the page and try again',
                            confirmButtonText: 'OK'
                        })
                    } else if (e.response.status !== 422) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Something went wrong',
                            html: 'Please refresh the page and try again',
                            confirmButtonText: 'OK'
                        })
                    }
                })
                .finally(() => {
                    this.submitText = true
                    this.loading = false
                })
        }
    }
}
</script>
<style scoped lang="scss">
.hint-text {
    color: $text-color-disabled;
    text-align: left;
}

.apply-heading {
    @include font-semi-bold();

    color: $btn-color;
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 5rem;
}

#contribute-about-section, #contribute-reasons-section {
    background-color: $dark-grey;
}

#contribute-about-section {
    padding-top: 20px;
    padding-bottom: 1px;
}

.contribute-about-section__row {
    margin: 110px -15px;

    h2 {
        @include font-semi-bold();
        font-size: 1.5rem;
        line-height: 2rem;
        color: $btn-color;
        margin-bottom: 28px;
    }

    p {
        color: $text-color-disabled;
        font-size: 1rem;
        line-height: 1.5rem;
        margin-bottom: 18px;
    }
}

.contribute-reasons-section__col {
    h2 {
        @include font-semi-bold();
        font-size: 1.5rem;
        color: $btn-color;
        margin-bottom: 15px;
    }

    p {
        color: $text-color-disabled;
        font-size: 1.2rem;
        margin-bottom: 18px;
        line-height: 1.5rem;
    }
}

.contribute-reasons-section__row {
    padding-bottom: 6.7rem;

    div[class^="col-"] {
        margin-top: 30px;
    }

    span {
        @include font-semi-bold();
        color: $btn-color;
        font-size: 1.5rem;
        margin-bottom: 10px;
        display: block;
    }

    p {
        color: $text-color;
        font-size: 1.2rem;
        line-height: 1.7rem;
    }
}

@media only screen and (max-width: 991px) {
    .apply-heading {
        margin-bottom: 3rem;
    }

    #contribute-about-section {
        padding-bottom: 5px;
    }

    .contribute-about-section__row {
        margin: 20px -15px;

        h2 {
            font-size: 1.3rem;
            line-height: 1.6rem;
            margin-bottom: 10px;
            margin-top: 15px;
        }

        p {
            font-size: 0.9rem;
            line-height: 1.4rem;
            margin-bottom: 8px;

            &:last-child {
                margin-bottom: 20px;
            }
        }
    }

    .contribute-reasons-section__col {
        h2 {
            font-size: 1.3rem;
            margin-bottom: 10px;
        }

        p {
            font-size: 0.9rem;
            margin-bottom: 10px;
        }
    }

    .contribute-reasons-section__row {
        padding-bottom: 3.7rem;

        div[class^="col-"] {
            margin-top: 20px;
        }

        span {
            font-size: 1.3rem;
            margin-bottom: 8px;
        }

        p {
            font-size: 1rem;

            br:not(.d-none) ~ br:not(.d-none) {
                display: none;
            }
        }
    }
}
</style>
